"use strict";

exports.__esModule = true;
exports.default = void 0;

var _reactTabs = require("react-tabs");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 1rem 0 0 0;\n\tborder-bottom: 1px solid ", "\n\tdisplay: flex;\n\tflex-wrap: wrap;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var StyledTabList = (0, _styledComponents.default)(_reactTabs.TabList)(_templateObject(), _colors.default.greyLight);
StyledTabList.displayName = 'StyledTabList';
StyledTabList.tabsRole = 'TabList';
/** @component */

var _default = StyledTabList;
exports.default = _default;